<!-- src/components/IntroTriggerBox.svelte
     v11 step 4 — 海峽中文名大標
     在「黑布拉上」階段顯示,讀者看到的就是這個元件的內容
     props:
       textContent: string  - 海峽中文名,例如「台灣海峽」
-->
<script>
  export let textContent = ''
</script>

<style>
  .intro-trigger-wrap {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    width: 80%;
    max-width: 600px;
    pointer-events: initial;
  }
  .intro-trigger-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
  }
  .intro-trigger-box h1 {
    font-size: clamp(2rem, 6vw, 4rem);
    letter-spacing: 0.2em;
    color: var(--color-curtain-text, #ffffff);
    font-weight: 300;
    margin: 0;
    /* 大標在深炭幕上,用淡淡光暈讓字更聚焦 */
    text-shadow: 0 2px 16px rgba(0, 0, 0, 0.4);
  }

  @media (max-width: 650px) {
    .intro-trigger-wrap {
      width: 90%;
    }
  }
</style>

<div class="intro-trigger-wrap">
  <div class="intro-trigger-box">
    <h1>{textContent}</h1>
  </div>
</div>
